import { fetchJson$ } from '@atlassian/jira-servicedesk-common/src/utils/fetch';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (
	baseUrl: string,
	projectKey: string, // eslint-disable-next-line @typescript-eslint/no-explicit-any
): any /* Observable<RestSummaryResponse>(../../types) */ =>
	fetchJson$(`${baseUrl}/rest/servicedesk/automation/1/pages/settings/automation/${projectKey}`, {
		method: 'GET',
	});
